import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import FormHelperText from "@mui/material/FormHelperText";
import Button from "@mui/material/Button";
import useTranslation from '../../../../translations/use-translation';
import "./ContactDetails.styles.scss";

const validate = (contacts) => {
  const errors = {};
  if (!contacts.currentAddress?.trim()) errors.currentAddress = 'Address is required';
  if (!contacts.cityDistrict?.trim())   errors.cityDistrict   = 'City / District is required';
  if (!contacts.pinCode?.toString().trim()) errors.pinCode    = 'PIN code is required';
  else if (!/^\d{6}$/.test(contacts.pinCode.toString().trim())) errors.pinCode = 'Enter a valid 6-digit PIN code';
  if (!contacts.state?.trim())          errors.state          = 'State is required';
  if (!contacts.country?.trim())        errors.country        = 'Country is required';
  return errors;
};

const Req = () => <span className="contact-details__required">*</span>;

const ContactDetails = ({ userProfile, setUserProfile }) => {
  const translate = useTranslation();
  const [errors, setErrors] = useState({});
  const [saved, setSaved]   = useState(false);

  const handleContactDetailsForm = (e) => {
    setUserProfile([{
      personal:  { ...userProfile[0].personal },
      contacts:  { ...userProfile[0].contacts, [e.target.name]: e.target.value },
      education: { ...userProfile[0].education },
      identity:  { ...userProfile[0].identity },
    }]);
    if (errors[e.target.name]) {
      setErrors((prev) => { const { [e.target.name]: _, ...rest } = prev; return rest; });
    }
  };

  const handleSave = () => {
    const errs = validate(userProfile[0].contacts);
    if (Object.keys(errs).length > 0) { setErrors(errs); return; }
    try {
      const existing = JSON.parse(localStorage.getItem('userExtendedProfile') || '{}');
      localStorage.setItem('userExtendedProfile', JSON.stringify({
        ...existing,
        contacts: userProfile[0].contacts,
      }));
      setSaved(true);
      setErrors({});
      setTimeout(() => setSaved(false), 2500);
    } catch { /* storage full */ }
  };

  return (
    <div className="contact-details-container">
      <div className="form-container">
        <div className="contact-form">
          <div className="form-title">Contact Information</div>

          <div className="form-fields">
            <div className="field-row">
              <div className="form-field">
                <label htmlFor="alternateNumber">{translate('ALTERNATE_MOBILE')}</label>
                <TextField
                  name="alternateNumber"
                  onChange={handleContactDetailsForm}
                  value={userProfile[0].contacts.alternateNumber}
                  id="alternateNumber"
                  fullWidth
                  variant="outlined"
                  className="modern-input"
                  type="tel"
                  inputProps={{ maxLength: 10 }}
                />
              </div>

              <div className="form-field">
                <label htmlFor="alternateEmail">{translate('ALTERNATE_EMAIL')}</label>
                <TextField
                  onChange={handleContactDetailsForm}
                  id="alternateEmail"
                  name="alternateEmail"
                  value={userProfile[0].contacts.alternateEmail}
                  fullWidth
                  variant="outlined"
                  className="modern-input"
                  type="email"
                />
              </div>
            </div>

            <div className="address-section">
              <div className="section-title">Address Information</div>

              <div className="field-row single-column">
                <div className="form-field">
                  <label htmlFor="currentAddress">{translate('ADDRESS')} <Req /></label>
                  <TextField
                    onChange={handleContactDetailsForm}
                    id="currentAddress"
                    name="currentAddress"
                    value={userProfile[0].contacts.currentAddress}
                    fullWidth
                    variant="outlined"
                    className="modern-input"
                    multiline
                    rows={3}
                    error={!!errors.currentAddress}
                    helperText={errors.currentAddress}
                  />
                </div>
              </div>

              <div className="field-row">
                <div className="form-field">
                  <label htmlFor="cityDistrict">{translate('DISTRICT_CITY')} <Req /></label>
                  <TextField
                    onChange={handleContactDetailsForm}
                    id="cityDistrict"
                    name="cityDistrict"
                    value={userProfile[0].contacts.cityDistrict}
                    fullWidth
                    variant="outlined"
                    className="modern-input"
                    error={!!errors.cityDistrict}
                    helperText={errors.cityDistrict}
                  />
                </div>

                <div className="form-field">
                  <label htmlFor="pinCode">{translate('PINCODE')} <Req /></label>
                  <TextField
                    onChange={handleContactDetailsForm}
                    id="pinCode"
                    name="pinCode"
                    value={userProfile[0].contacts.pinCode}
                    fullWidth
                    variant="outlined"
                    className="modern-input"
                    inputProps={{ maxLength: 6 }}
                    error={!!errors.pinCode}
                    helperText={errors.pinCode}
                  />
                </div>
              </div>

              <div className="field-row">
                <div className="form-field">
                  <label htmlFor="state">{translate('STATE')} <Req /></label>
                  <TextField
                    onChange={handleContactDetailsForm}
                    id="state"
                    name="state"
                    value={userProfile[0].contacts.state}
                    fullWidth
                    variant="outlined"
                    className="modern-input"
                    error={!!errors.state}
                    helperText={errors.state}
                  />
                </div>

                <div className="form-field">
                  <label htmlFor="country">{translate('COUNTRY')} <Req /></label>
                  <TextField
                    onChange={handleContactDetailsForm}
                    id="country"
                    name="country"
                    value={userProfile[0].contacts.country}
                    fullWidth
                    variant="outlined"
                    className="modern-input"
                    error={!!errors.country}
                    helperText={errors.country}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="form-actions">
            <Button className="btn-save" variant="contained" onClick={handleSave}>
              {saved ? 'Saved!' : translate('SAVE')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactDetails;
